<template>
  <div class="container">
    <b-card
      border-variant="secondary"
      class="text-center mt-1"
    >
      <div class="col-sm-12">
        <!-- <b-button
          v-show="buttonShowZarva"
          size="sm"
          variant="outline-danger"
          class="mr-1"
          ><b-icon-key-fill></b-icon-key-fill>
          ZÁRVA
        </b-button> -->
        <div class="row">
          <h4>ID: {{list[0].id}}</h4>
        </div>
        <div class="row">
          <h4>http://brand-max.hu/#/munkalap/{{list[0].id}}</h4>
        </div>
      </div>

      <!-- // TABLE -->
      <div class="mt-3">
        <b-table class="labelsize table-striped" hover :items="list" :fields="fields" :key="list[0].id">

          <!-- // EDIT -->
          <template v-if="userType=='admin' || userType=='user'" v-slot:cell(edit)="row">
            <b-button
              v-if="row.item.closed == 0"
              size="sm"
              @click="
                $router.push({
                  name: 'Calculator',
                  params: { id: row.item.id }
                })
              "
              variant="outline-success"
              class="mr-0"
            ><b-icon-pencil></b-icon-pencil>
            </b-button>
          </template>

          <!-- // MINICRM LINK -->
          <template v-slot:cell(emaillink)="row" class="mb-1">
            <b-button
              size="sm"
              @click="redirect(row.item.emaillink)"
              variant="outline-danger"
              class="mr-1"
              >
              LINK
            </b-button>
          </template>

        </b-table>

        <!-- //PDF -->
        <div>
          <b-button
            v-show="buttonShow"
            size="sm"
            variant="outline-danger"
            @click="printFile(list[0].id)"
            class="mr-0"
            ><img style="width: 20px;" src="../assets/pdf-icon.png" alt="">
            generálás
          </b-button>

          <!-- <b-button
            v-show="buttonShow"
            size="sm"
            variant="outline-danger"
            @click="showMsgBox()"
            class="mr-0 float-right"
            ><b-icon-key-fill></b-icon-key-fill>
            Lezárás
          </b-button> -->
        </div>

      </div>
    </b-card>

    <b-card
      border-variant="secondary"
      class="text-center mt-1"
    >
      <div class="col-sm-12">
        <div class="row">
          <h4>Kiadott árajánlat</h4>
          <table class="table">
            <thead>
              <tr>
                <th>pdf</th>
                <th>Verzió</th>
                <th>Dátum</th>
                <th>Fájlnév</th>
                <th>K</th>
                <th>PRINT</th>
              </tr>
            </thead>
            <tbody>
              <tr  v-for="(element) in files" :key="element.id">
                <td>
                  <img style="width: 25px;" src="../assets/pdf-icon.png" alt="">
                </td>
                <td>v{{element.version}}</td>
                <td>
                  {{element.created}}
                </td>
                <td>{{element.filename}}</td>
                <td>{{element.monogram}}</td>
                <td>
                  <b-button
                    size="sm"
                    variant="outline-success"
                    @click="downloadFile(element)"
                    class="mr-0"
                    ><b-icon-printer></b-icon-printer>
                  </b-button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

    </b-card>

  </div>

</template>

<script>
import axios from 'axios'
import router from '../router'
import VueHtml2pdf from 'vue-html2pdf'
import jwtDecode from 'jwt-decode'
import moment from 'moment'
import { saveAs } from 'file-saver'

export default {
  components: {
    VueHtml2pdf
  },
  data () {
    const token = localStorage.usertoken
    const decoded = jwtDecode(token)
    return {
      dateconvert: null,
      EgyebTetelekShow: false,
      tableHeadShow: false,
      boxTwo: '',
      token: localStorage.usertoken,
      auth: '',
      userType: decoded.usertype,
      monogram: decoded.monogram,
      filters: [
        'Minden oszlop',
        'id',
        'Dátum',
        'MiniCRM adatlap neve',
        'Kat',
        'K',
        'Státusz',
        'Megjegyzés',
        'Végösszeg'
      ],
      filterSelect: '',
      list: [],
      fields: [
        {
          key: 'id',
          label: 'Id',
          sortable: true,
          sortDirection: 'desc'
        },
        { key: 'edit', sortable: false },
        {
          key: 'emaillink',
          label: 'CRM',
          sortable: true,
          sortDirection: 'desc',
          tdClass: 'text-right',
          thClass: 'text-right'
        },
        {
          key: 'created',
          formatter: (value, key, item) => {
            return moment(value).format('YYYY-MM-DD HH:mm:ss')
          },
          label: 'Dátum',
          sortable: true,
          sortDirection: 'desc'
        },
        {
          key: 'partner',
          label: 'MiniCRM adatlap neve',
          sortable: true,
          sortDirection: 'desc',
          tdClass: 'text-left',
          thClass: 'text-left'
        },
        {
          key: 'partnerkategoria',
          label: 'Kat',
          sortable: true,
          sortDirection: 'desc'
        },
        {
          key: 'kiallito',
          label: 'K',
          sortable: true,
          sortDirection: 'desc'
        },
        {
          key: 'statusnev',
          label: 'Státusz',
          sortable: true,
          sortDirection: 'desc'
        },
        {
          key: 'megjegyzes',
          label: 'Megjegyzés',
          sortable: true,
          sortDirection: 'desc',
          tdClass: 'text-left',
          thClass: 'text-left'
        },
        {
          key: 'vegosszeg',
          label: 'Végösszeg',
          sortable: true,
          sortDirection: 'desc',
          tdClass: 'text-right',
          thClass: 'text-right'
        }
        // { key: 'send', sortable: false },
      ],
      myTempAnyagTipus: [],
      searchText: '',
      files: [],
      buttonShow: true,
      buttonShowZarva: false
    }
  },
  methods: {
    redirect: function (link, target = '_blank') {
      window.open(link, target)
    },
    downloadFile (req) {
      let payload = {}
      if (!this.token) {
        router.push({ name: 'Login' })
      } else {
        payload.token = this.token
        payload.userType = this.userType
        payload.filename = req.filename

        axios.post('https://' + process.env.ROOT_API + '/file/downloadfile', {payload}, {
          responseType: 'arraybuffer'
        }).then(res => {
          const url = window.URL.createObjectURL(new Blob([res.data], {type: 'application/pdf;charset=utf-8'}))
          window.open(url, '_blank')
          // let blob = new Blob([res.data], {type: "application/pdf;charset=utf-8"});
          // saveAs(blob, payload.filename);
        })
          .catch(err => {
            console.log(err)
          })
      }
    },
    printFile (req) {
      let payload = {}
      if (!this.token) {
        router.push({ name: 'Login' })
      } else {
        payload.token = this.token
        payload.userType = this.userType
        payload.id = this.list[0].id
        payload.monogram = this.monogram

        axios.post('https://' + process.env.ROOT_API + '/file/printfile', {payload}, {
        }).then(res => {
          this.loadList()
          console.log(res)
          this.downloadFile(res.data)
          // let blob = new Blob([res.data], {type: "application/pdf;charset=utf-8"});
          // saveAs(blob, res.data.filename);
        })
          .catch(err => {
            console.log(err)
          })
      }
    },
    closeDocument: function (req) {
      let payload = {}
      if (!this.token) {
        router.push({ name: 'Login' })
      } else {
        payload.token = this.token
        payload.userType = this.userType
        payload.id = this.list[0].id
        axios
          .post('https://' + process.env.ROOT_API + '/munkak/close', { payload })
          .then(res => {
            this.loadList()
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    showMsgBox () {
      this.boxTwo = ''
      this.$bvModal
        .msgBoxConfirm('Munkalap végleges lezárása! Utólagos szerkesztés többször már nem lehetséges! Biztos vagy benne, hogy lezárod? ', {
          title: 'Megerősítés',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'IGEN',
          cancelTitle: 'NEM',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value) this.closeDocument()
        })
        .catch(err => {
          console.log(err)
        })
    },
    loadList () {
      let payload = {}
      if (!this.token) {
        router.push({ name: 'Login' })
      } else {
        payload.id = this.$route.params.id
        payload.token = this.token
        payload.userType = this.userType
        axios.post('https://' + process.env.ROOT_API + '/munkak/getlist', {payload})
          .then(res => {
            this.list = res.data
            if (this.list[0].closed === 1) {
              this.buttonShow = false
              this.buttonShowZarva = true
            } else {
              this.buttonShow = true
              this.buttonShowZarva = false
            }
            if (this.userType === 'gyartas') this.buttonShow = false
          })
          .catch(err => {
            console.log(err)
          })
        axios.post('https://' + process.env.ROOT_API + '/file/getlist', {payload})
          .then(res => {
            this.files = res.data
            for (var el in this.files) {
              this.files[el].created = moment(String(this.files[el].created)).format('YYYY-MM-DD HH:mm:ss')
            }
          })
          .catch(err => {
            console.log(err)
          })
      }
    }
  },
  mounted: function () {
    this.loadList()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Munkalap.vue